// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectSolUseClassificationQueryResult, selectSolUseClassificationsPageLoading, selectSolUseClassificationsShowInitWaitingMessage} from '../_selectors/sol-use-classification.selectors';

export class SolUseClassificationsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectSolUseClassificationsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectSolUseClassificationsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectSolUseClassificationQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
